<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '350px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="ibox-content">
	<div class="TopMenuDiv">
		<div class="SchoolSelectDiv">
			<label class="control-label NoMarign">School</label>

			<caass-schoolselector [ShowAll]="SchoolSelectShowAll" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText">
			</caass-schoolselector>
		</div>

		<div>
			<button class="btn btn-primary control-label NoMarign" (click)="ConfirmUploadImages($event)">Upload {{ TotalImagesLoaded.length }} Photos</button>
		</div>
	</div>
</div>

<!-- 						-->
<!-- Select Photo Buttons 	-->
<!-- 						-->
<div class="ibox-content">
	<form name="ActionForm" class="form-horizontal" role="form" novalidate>
		<div>
			<div style="margin-left: 5px; margin-top: 5px; margin-bottom: 0px">
				<span style="font-weight: bold; font-style: italic; color: rgb(0, 127, 0)">CTL+A</span>
				<span style="color: rgb(0, 0, 0); margin-left: 5px">will select all images</span>
				<span style="margin-left: 25px; display: inline-block">&nbsp;</span>
				<span style="font-weight: bold; font-style: italic; color: rgb(0, 127, 0)">CTL+Click</span>
				<span style="color: rgb(0, 0, 0); margin-left: 5px">will select multiple images</span>
			</div>
			<br />

			<!-- Image File Selector Button -->
			<label for="fileSelectImages" class="btn btn-primary mt-2 ml-2" style="margin-left: 0px">Select Photos</label>
			<input
				id="fileSelectImages"
				type="file"
				(change)="LoadImages($event)"
				onclick="event.target.value=''"
				style="visibility: hidden; position: absolute"
				accept="image/*"
				multiple
			/>

			<!-- Clear Images Button -->
			<button class="btn btn-primary" style="margin-left: 5px" (click)="ClearImages()">Clear Photos</button>

			<!-- TEST Button -->
			<!-- <button class="btn btn-primary" (click)="GetData()">Get Data</button> -->

			<!-- SelectedCounts[]
					0 = [Selected Count] 
					1 = [Selected Loaded Success Count] 
					2 = [Selected Loaded Error Count]
					3 = [IsLoading] 
					4 = [TotalImagesToUpload] 
					5 = [TotalImagesUploaded]
					6 = [IsUploading]
			-->
			<label
				style="margin-left: 5px; margin-top: 5px; margin-bottom: 0px"
				[style.display]="SelectedCounts[3] == 1 && SelectedCounts[6] == 0 ? 'block' : 'none'"
			>
				Please wait while loading images... {{ SelectedCounts[1] }} of {{ SelectedCounts[0] }} / ({{
					(SelectedCounts[1] / SelectedCounts[0]) * 100 | number : "1.0-0"
				}}%)
			</label>

			<label
				style="margin-left: 5px; margin-top: 5px; margin-bottom: 0px"
				[style.display]="SelectedCounts[3] == 0 && SelectedCounts[0] != 0 && SelectedCounts[6] == 0 ? 'block' : 'none'"
			>
				Loading Complete...
			</label>

			<label style="margin-left: 5px; margin-top: 5px; margin-bottom: 0px" [style.display]="SelectedCounts[6] == 1 ? 'block' : 'none'">
				Please wait while Uploading images to CAASS...
				{{ SelectedCounts[5] }} of {{ SelectedCounts[4] }} / ({{ (SelectedCounts[5] / SelectedCounts[4]) * 100 | number : "1.0-0" }}%)
			</label>

			<label
				style="margin-left: 5px; margin-top: 5px; margin-bottom: 0px"
				[style.display]="SelectedCounts[6] == 0 && SelectedCounts[5] != 0 && TotalImagesLoaded.length == 0 ? 'block' : 'none'"
			>
				Upload Complete...
			</label>
		</div>
	</form>
</div>

<!-- 				-->
<!-- Display Photos -->
<!-- 				-->
<div class="ibox-content">
	<div class="flex-container">
		<div *ngFor="let obj of TotalImagesLoaded">
			<div style="margin: 5px">
				<div>
					<img style="margin-top: 2px; margin-bottom: 0px; margin-right: 2px; margin-left: 2px" [src]="obj.PhotoUrl" width="160" />
				</div>
				<div style="margin-top: 0px; margin-bottom: 2px; margin-right: 2px; margin-left: 2px; background-color: rgb(194, 194, 194)">
					<label style="margin-top: 2px; color: black; word-wrap: break-word">{{ obj.PhotoName }}</label>
				</div>
			</div>
		</div>
	</div>
</div>
